import { i18n } from '@/i18n.js';

const attachmentCategories = Object.freeze({
  InvestigationImpactsGuardian: 36,
  InvestigationImpactsTeachers: 37,
  InvestigationImpactsPrincipal: 38,
  InvestigationImpactsStudents: 39,
  InvestigationShareTeachers: 40,
  InvestigationInpactsGeneral: 47,
  InstitutionalReviewBoard: 82
});

export const attachmentCategoryDescriptions = Object.freeze({
  [attachmentCategories.InvestigationImpactsGuardian]:
    i18n.locale == 'es'
      ? 'Carta Consentimiento Informado para madre, padre o encargados'
      : 'Informed Consent Letter for mother, father or guardians',
  [attachmentCategories.InvestigationImpactsTeachers]:
    i18n.locale == 'es'
      ? 'Carta Consentimiento Informado para Maestros'
      : 'Informed Consent Letter for Teachers',
  [attachmentCategories.InvestigationImpactsPrincipal]:
    i18n.locale == 'es'
      ? 'Carta Consentimiento Informado a Directores'
      : 'Informed Consent Letter to Directors',
  [attachmentCategories.InvestigationImpactsStudents]:
    i18n.locale == 'es'
      ? 'Carta Asentimiento Informado a Estudiantes'
      : 'Letter of Informed Assent to Students',
  [attachmentCategories.InvestigationShareTeachers]:
    i18n.locale == 'es'
      ? 'Carta de Colaboración para Maestros'
      : 'Collaboration Letter for Teachers',
  [attachmentCategories.InvestigationInpactsGeneral]:
    i18n.locale == 'es'
      ? 'Carta Consentimiento General o a otros Participantes [Trabajador Social, Orientadores, etc]'
      : 'General Consent Letter or to other Participants [Social Worker, Guidance, etc.]',
  [attachmentCategories.InstitutionalReviewBoard]:
      i18n.locale == 'es'
        ? 'Junta de Revisión Institucional'
        : 'Institutional Review Board',
});

export default attachmentCategories;
